import React from 'react';
import FlyttstadningBase from './flyttstadning-base';

function FlyttstadningIStockholm() {
  return (
    <FlyttstadningBase
      
      city="Stockholm"
      backgroundImage="/images/cleaning/stockholm.webp"
      rubrikOne={`Vi erbjuder flyttstädning i hela Stockholm, inklusive Södermalm, Kungsholmen, Vasastan och Bromma.`}
      rubrikTwo={`Eftersom Stockholm är en storstad med många flyttar varje dag, kan vi oftast boka in din städning med kort varsel.`}
      backgroundOpacityClass= "bg-opacity-50"
    />
  );
}

export default FlyttstadningIStockholm;
